import { Entity } from "game-common/models"
import { ApplyInputResultPool } from "game-common/apply_input_result_pool"
import { TileMapMetaProvider } from "game-common/tile_map_meta_provider"
import { shotMover } from "game-common/spent_arrow_landing"

/** Advance local projectile playback. The caller owns removal or hiding until server removal. */
export function advanceProjectile(bullet: Entity, dt: number, map: TileMapMetaProvider): boolean {
    if (bullet.isDead()) return false
    if (dt <= 0) return true
    if (bullet.crossFloorProjectile) {
        bullet.location.x += bullet.speed2.x * dt
        bullet.location.y += bullet.speed2.y * dt
        return true
    }
    const result = ApplyInputResultPool.instance.checkout()
    try {
        // Through the server's own mover: stopped at a cliff's face it meets low, as the server stops it.
        bullet.applyInput(undefined, dt, bullet.speed2, result.data, shotMover(map, bullet), true)
        return !!(result.data.movedX || result.data.movedY) &&
            !(bullet.maxDistance !== undefined && bullet.travelledDistance() > bullet.maxDistance)
    } finally { ApplyInputResultPool.instance.release(result) }
}
